import Link from 'next/link'
import ErrorCard from './error-card'

const NoCookies = ({ desc }) => {
  return (
    <ErrorCard className='whitespace-normal h-auto p-2 rounded-md'>
      You have opted out of cookies: {desc}. Go to your 
      <Link className='text-chlinks-100 font-bold' href={'/account'} as={`/account`}>Account</Link> page and <span className='font-bold'>Enable Cookies</span>. 
      <Link className='text-chlinks-100 font-bold' href={'/cookies'} as={`/cookies`}>Cookie Policy</Link>.
    </ErrorCard>
  );
}

export default NoCookies
